import { PageViewEventLogger } from '@repo/tracking-service';
import { AuthGuard } from '@repo/user-session';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { useLazyLoadQuery } from 'react-relay';

import type { lookupUserQuery } from '@/__generated__/lookupUserQuery.graphql';
import Layout from '@/components/layout/Layout';
import { CancelContent } from '@/components/tax-refund/cancel/CancelContent';
import { lookupUser } from '@/graphql/query/lookup-user';
import { SUPPORT_BOT_LINK } from '@/lib/constants/link';
import { COMMON_PATHS, INDIVIDUAL_PATHS } from '@/lib/constants/paths';
import { zCurrency } from '@/lib/utils/zCurrency';

const IndisCancelPage = () => {
  const router = useRouter();
  const data = useLazyLoadQuery<lookupUserQuery>(lookupUser, {}, {});
  const { type } = router.query;

  const eventProperty = useMemo((): Record<string, string> => {
    if (type === 'indis-tritx') {
      return { type: 'capital-gain' };
    }
    if (type === 'indis') {
      return { type: 'global-income' };
    }
    return {};
  }, [type]);

  let userData;

  if (type === 'indis-tritx') {
    userData = data?.bznavRefund?.user?.tritxIndis;
  } else {
    userData = data?.bznavRefund?.user?.indis;
  }

  if (!userData || userData.length !== 1) {
    router.push({ pathname: COMMON_PATHS.환급신청결과, query: router.query });
    return <></>;
  }

  const item = userData[0];
  const name = item?.businessInfo?.taxpayerName ?? '고객';
  const payAmount = zCurrency(item?.refundAmount, '', true, '0');
  const discountRate = item?.partnerInfo?.discountRate;

  return (
    <AuthGuard>
      <PageViewEventLogger pageName="indis-cancel" eventName="indis-cancel_defense" eventProperty={eventProperty}>
        <Layout
          leftIcon={{
            icon: 'back',
            clickEvent: { name: 'indis-cancel_topnav_back' }
          }}
        >
          <CancelContent
            name={name}
            payAmount={payAmount}
            discountRate={discountRate}
            resultPath={COMMON_PATHS.환급신청결과}
            reasonPath={INDIVIDUAL_PATHS.개인취소사유}
            supportBotLink={SUPPORT_BOT_LINK.default}
            titleSuffix="님"
            businessType={'indis'}
          />
        </Layout>
      </PageViewEventLogger>
    </AuthGuard>
  );
};

export default IndisCancelPage;
